(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6790,7993],{

/***/ 72779:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 98485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CircularProgress_CircularProgress; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(77597);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js + 1 modules
var emotion_react_browser_esm = __webpack_require__(81992);
// EXTERNAL MODULE: ../../node_modules/@mui/material/utils/capitalize.js + 1 modules
var capitalize = __webpack_require__(8036);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(74017);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(67393);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(72606);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(98922);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/CircularProgress/circularProgressClasses.js

function getCircularProgressUtilityClass(slot) {
    return (0,generateUtilityClass/* default */.Z)("MuiCircularProgress", slot);
}
var circularProgressClasses = (0,generateUtilityClasses/* default */.Z)("MuiCircularProgress", [
    "root",
    "determinate",
    "indeterminate",
    "colorPrimary",
    "colorSecondary",
    "svg",
    "circle",
    "circleDeterminate",
    "circleIndeterminate",
    "circleDisableShrink"
]);
/* harmony default export */ var CircularProgress_circularProgressClasses = ((/* unused pure expression or super */ null && (circularProgressClasses)));

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/CircularProgress/CircularProgress.js

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    stroke-dasharray: 1px, 200px;\n    stroke-dashoffset: 0;\n  }\n\n  50% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -15px;\n  }\n\n  100% {\n    stroke-dasharray: 100px, 200px;\n    stroke-dashoffset: -125px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 1.4s linear infinite;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      animation: ",
        " 1.4s ease-in-out infinite;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var _excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
var _ = function(t) {
    return t;
}, _t, _t2, _t3, _t4;











var SIZE = 44;
var circularRotateKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t || (_t = _(_templateObject())));
var circularDashKeyframe = (0,emotion_react_browser_esm/* keyframes */.F4)(_t2 || (_t2 = _(_templateObject1())));
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, variant = ownerState.variant, color = ownerState.color, disableShrink = ownerState.disableShrink;
    var slots = {
        root: [
            "root",
            variant,
            "color".concat((0,capitalize/* default */.Z)(color))
        ],
        svg: [
            "svg"
        ],
        circle: [
            "circle",
            "circle".concat((0,capitalize/* default */.Z)(variant)),
            disableShrink && "circleDisableShrink"
        ]
    };
    return (0,composeClasses/* default */.Z)(slots, getCircularProgressUtilityClass, classes);
};
var CircularProgressRoot = (0,styled/* default */.ZP)("span", {
    name: "MuiCircularProgress",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles[ownerState.variant],
            styles["color".concat((0,capitalize/* default */.Z)(ownerState.color))]
        ];
    }
})(function(param) {
    var ownerState = param.ownerState, theme = param.theme;
    return (0,esm_extends/* default */.Z)({
        display: "inline-block"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("transform")
    }, ownerState.color !== "inherit" && {
        color: theme.palette[ownerState.color].main
    });
}, function(param) {
    var ownerState = param.ownerState;
    return ownerState.variant === "indeterminate" && (0,emotion_react_browser_esm/* css */.iv)(_t3 || (_t3 = _(_templateObject2(), 0)), circularRotateKeyframe);
});
var CircularProgressSVG = (0,styled/* default */.ZP)("svg", {
    name: "MuiCircularProgress",
    slot: "Svg",
    overridesResolver: function(props, styles) {
        return styles.svg;
    }
})({
    display: "block" // Keeps the progress centered
});
var CircularProgressCircle = (0,styled/* default */.ZP)("circle", {
    name: "MuiCircularProgress",
    slot: "Circle",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.circle,
            styles["circle".concat((0,capitalize/* default */.Z)(ownerState.variant))],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(function(param) {
    var ownerState = param.ownerState, theme = param.theme;
    return (0,esm_extends/* default */.Z)({
        stroke: "currentColor"
    }, ownerState.variant === "determinate" && {
        transition: theme.transitions.create("stroke-dashoffset")
    }, ownerState.variant === "indeterminate" && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: "80px, 200px",
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    });
}, function(param) {
    var ownerState = param.ownerState;
    return ownerState.variant === "indeterminate" && !ownerState.disableShrink && (0,emotion_react_browser_esm/* css */.iv)(_t4 || (_t4 = _(_templateObject3(), 0)), circularDashKeyframe);
});
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ var CircularProgress = /*#__PURE__*/ react.forwardRef(function CircularProgress(inProps, ref) {
    var props = (0,useThemeProps/* default */.Z)({
        props: inProps,
        name: "MuiCircularProgress"
    });
    var className = props.className, _color = props.color, color = _color === void 0 ? "primary" : _color, _disableShrink = props.disableShrink, disableShrink = _disableShrink === void 0 ? false : _disableShrink, _size = props.size, size = _size === void 0 ? 40 : _size, style = props.style, _thickness = props.thickness, thickness = _thickness === void 0 ? 3.6 : _thickness, _value = props.value, value = _value === void 0 ? 0 : _value, _variant = props.variant, variant = _variant === void 0 ? "indeterminate" : _variant, other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    var ownerState = (0,esm_extends/* default */.Z)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    var classes = useUtilityClasses(ownerState);
    var circleStyle = {};
    var rootStyle = {};
    var rootProps = {};
    if (variant === "determinate") {
        var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps["aria-valuenow"] = Math.round(value);
        circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
        rootStyle.transform = "rotate(-90deg)";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgressRoot, (0,esm_extends/* default */.Z)({
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        style: (0,esm_extends/* default */.Z)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: SIZE,
                cy: SIZE,
                r: (SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
 false ? 0 : void 0;
/* harmony default export */ var CircularProgress_CircularProgress = (CircularProgress);


/***/ }),

/***/ 84419:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Step_Step; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(77597);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stepper/StepperContext.js
var StepperContext = __webpack_require__(73451);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Step/StepContext.js
var StepContext = __webpack_require__(14202);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(74017);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(67393);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(72606);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(98922);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Step/stepClasses.js

function getStepUtilityClass(slot) {
    return (0,generateUtilityClass/* default */.Z)("MuiStep", slot);
}
var stepClasses = (0,generateUtilityClasses/* default */.Z)("MuiStep", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel",
    "completed"
]);
/* harmony default export */ var Step_stepClasses = ((/* unused pure expression or super */ null && (stepClasses)));

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Step/Step.js


var _excluded = [
    "active",
    "children",
    "className",
    "completed",
    "disabled",
    "expanded",
    "index",
    "last"
];












var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, orientation = ownerState.orientation, alternativeLabel = ownerState.alternativeLabel, completed = ownerState.completed;
    var slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel",
            completed && "completed"
        ]
    };
    return (0,composeClasses/* default */.Z)(slots, getStepUtilityClass, classes);
};
var StepRoot = (0,styled/* default */.ZP)("div", {
    name: "MuiStep",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(function(param) {
    var ownerState = param.ownerState;
    return (0,esm_extends/* default */.Z)({}, ownerState.orientation === "horizontal" && {
        paddingLeft: 8,
        paddingRight: 8
    }, ownerState.alternativeLabel && {
        flex: 1,
        position: "relative"
    });
});
var Step = /*#__PURE__*/ react.forwardRef(function Step(inProps, ref) {
    var props = (0,useThemeProps/* default */.Z)({
        props: inProps,
        name: "MuiStep"
    });
    var activeProp = props.active, children = props.children, className = props.className, completedProp = props.completed, disabledProp = props.disabled, _expanded = props.expanded, expanded = _expanded === void 0 ? false : _expanded, index = props.index, last = props.last, other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    var _$ref = react.useContext(StepperContext/* default */.Z), activeStep = _$ref.activeStep, connector = _$ref.connector, alternativeLabel = _$ref.alternativeLabel, orientation = _$ref.orientation, nonLinear = _$ref.nonLinear;
    var _$ref1 = [
        activeProp,
        completedProp,
        disabledProp
    ], tmp = _$ref1[0], active = tmp === void 0 ? false : tmp, tmp1 = _$ref1[1], completed = tmp1 === void 0 ? false : tmp1, tmp2 = _$ref1[2], disabled = tmp2 === void 0 ? false : tmp2;
    if (activeStep === index) {
        active = activeProp !== undefined ? activeProp : true;
    } else if (!nonLinear && activeStep > index) {
        completed = completedProp !== undefined ? completedProp : true;
    } else if (!nonLinear && activeStep < index) {
        disabled = disabledProp !== undefined ? disabledProp : true;
    }
    var contextValue = react.useMemo(function() {
        return {
            index: index,
            last: last,
            expanded: expanded,
            icon: index + 1,
            active: active,
            completed: completed,
            disabled: disabled
        };
    }, [
        index,
        last,
        expanded,
        active,
        completed,
        disabled
    ]);
    var ownerState = (0,esm_extends/* default */.Z)({}, props, {
        active: active,
        orientation: orientation,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        expanded: expanded
    });
    var classes = useUtilityClasses(ownerState);
    var newChildren = /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepRoot, (0,esm_extends/* default */.Z)({
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            connector && alternativeLabel && index !== 0 ? connector : null,
            children
        ]
    }));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepContext/* default.Provider */.Z.Provider, {
        value: contextValue,
        children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                connector,
                newChildren
            ]
        }) : newChildren
    });
});
 false ? 0 : void 0;
/* harmony default export */ var Step_Step = (Step);


/***/ }),

/***/ 14202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export useStepContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

/**
 * Provides information about the current step in Stepper.
 */ var StepContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
if (false) {}
/**
 * Returns the current StepContext or an empty object if no StepContext
 * has been defined in the component tree.
 */ function useStepContext() {
    return React.useContext(StepContext);
}
/* harmony default export */ __webpack_exports__["Z"] = (StepContext);


/***/ }),

/***/ 83375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StepLabel_StepLabel; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(77597);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(67393);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(74017);
// EXTERNAL MODULE: ../../node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(35986);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/internal/svg-icons/CheckCircle.js


/**
 * @ignore - internal component.
 */ 
/* harmony default export */ var CheckCircle = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle"));

;// CONCATENATED MODULE: ../../node_modules/@mui/material/internal/svg-icons/Warning.js


/**
 * @ignore - internal component.
 */ 
/* harmony default export */ var Warning = ((0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning"));

// EXTERNAL MODULE: ../../node_modules/@mui/material/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(82175);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(72606);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(98922);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/StepIcon/stepIconClasses.js

function getStepIconUtilityClass(slot) {
    return (0,generateUtilityClass/* default */.Z)("MuiStepIcon", slot);
}
var stepIconClasses = (0,generateUtilityClasses/* default */.Z)("MuiStepIcon", [
    "root",
    "active",
    "completed",
    "error",
    "text"
]);
/* harmony default export */ var StepIcon_stepIconClasses = (stepIconClasses);

;// CONCATENATED MODULE: ../../node_modules/@mui/material/StepIcon/StepIcon.js



var _circle;
var _excluded = [
    "active",
    "className",
    "completed",
    "error",
    "icon"
];












var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, active = ownerState.active, completed = ownerState.completed, error = ownerState.error;
    var slots = {
        root: [
            "root",
            active && "active",
            completed && "completed",
            error && "error"
        ],
        text: [
            "text"
        ]
    };
    return (0,composeClasses/* default */.Z)(slots, getStepIconUtilityClass, classes);
};
var StepIconRoot = (0,styled/* default */.ZP)(SvgIcon/* default */.Z, {
    name: "MuiStepIcon",
    slot: "Root",
    overridesResolver: function(props, styles) {
        return styles.root;
    }
})(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        display: "block",
        transition: theme.transitions.create("color", {
            duration: theme.transitions.duration.shortest
        }),
        color: theme.palette.text.disabled
    }, (0,_define_property/* default */.Z)(_obj, "&.".concat(StepIcon_stepIconClasses.completed), {
        color: theme.palette.primary.main
    }), (0,_define_property/* default */.Z)(_obj, "&.".concat(StepIcon_stepIconClasses.active), {
        color: theme.palette.primary.main
    }), (0,_define_property/* default */.Z)(_obj, "&.".concat(StepIcon_stepIconClasses.error), {
        color: theme.palette.error.main
    }), _obj;
});
var StepIconText = (0,styled/* default */.ZP)("text", {
    name: "MuiStepIcon",
    slot: "Text",
    overridesResolver: function(props, styles) {
        return styles.text;
    }
})(function(param) {
    var theme = param.theme;
    return {
        fill: theme.palette.primary.contrastText,
        fontSize: theme.typography.caption.fontSize,
        fontFamily: theme.typography.fontFamily
    };
});
var StepIcon = /*#__PURE__*/ react.forwardRef(function StepIcon(inProps, ref) {
    var props = (0,useThemeProps/* default */.Z)({
        props: inProps,
        name: "MuiStepIcon"
    });
    var _active = props.active, active = _active === void 0 ? false : _active, classNameProp = props.className, _completed = props.completed, completed = _completed === void 0 ? false : _completed, _error = props.error, error = _error === void 0 ? false : _error, icon = props.icon, other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    var ownerState = (0,esm_extends/* default */.Z)({}, props, {
        active: active,
        completed: completed,
        error: error
    });
    var classes = useUtilityClasses(ownerState);
    if (typeof icon === "number" || typeof icon === "string") {
        var className = (0,clsx_m/* default */.Z)(classNameProp, classes.root);
        if (error) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepIconRoot, (0,esm_extends/* default */.Z)({
                as: Warning,
                className: className,
                ref: ref,
                ownerState: ownerState
            }, other));
        }
        if (completed) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepIconRoot, (0,esm_extends/* default */.Z)({
                as: CheckCircle,
                className: className,
                ref: ref,
                ownerState: ownerState
            }, other));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepIconRoot, (0,esm_extends/* default */.Z)({
            className: className,
            ref: ref,
            ownerState: ownerState
        }, other, {
            children: [
                _circle || (_circle = /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "12"
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StepIconText, {
                    className: classes.text,
                    x: "12",
                    y: "16",
                    textAnchor: "middle",
                    ownerState: ownerState,
                    children: icon
                })
            ]
        }));
    }
    return icon;
});
 false ? 0 : void 0;
/* harmony default export */ var StepIcon_StepIcon = (StepIcon);

// EXTERNAL MODULE: ../../node_modules/@mui/material/Stepper/StepperContext.js
var StepperContext = __webpack_require__(73451);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Step/StepContext.js
var StepContext = __webpack_require__(14202);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/StepLabel/stepLabelClasses.js

function getStepLabelUtilityClass(slot) {
    return (0,generateUtilityClass/* default */.Z)("MuiStepLabel", slot);
}
var stepLabelClasses = (0,generateUtilityClasses/* default */.Z)("MuiStepLabel", [
    "root",
    "horizontal",
    "vertical",
    "label",
    "active",
    "completed",
    "error",
    "disabled",
    "iconContainer",
    "alternativeLabel",
    "labelContainer"
]);
/* harmony default export */ var StepLabel_stepLabelClasses = (stepLabelClasses);

;// CONCATENATED MODULE: ../../node_modules/@mui/material/StepLabel/StepLabel.js



var StepLabel_excluded = [
    "children",
    "className",
    "componentsProps",
    "error",
    "icon",
    "optional",
    "StepIconComponent",
    "StepIconProps"
];












var StepLabel_useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, orientation = ownerState.orientation, active = ownerState.active, completed = ownerState.completed, error = ownerState.error, disabled = ownerState.disabled, alternativeLabel = ownerState.alternativeLabel;
    var slots = {
        root: [
            "root",
            orientation,
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        label: [
            "label",
            active && "active",
            completed && "completed",
            error && "error",
            disabled && "disabled",
            alternativeLabel && "alternativeLabel"
        ],
        iconContainer: [
            "iconContainer",
            alternativeLabel && "alternativeLabel"
        ],
        labelContainer: [
            "labelContainer"
        ]
    };
    return (0,composeClasses/* default */.Z)(slots, getStepLabelUtilityClass, classes);
};
var StepLabelRoot = (0,styled/* default */.ZP)("span", {
    name: "MuiStepLabel",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles[ownerState.orientation]
        ];
    }
})(function(param) {
    var ownerState = param.ownerState;
    var _obj;
    return (0,esm_extends/* default */.Z)((_obj = {
        display: "flex",
        alignItems: "center"
    }, (0,_define_property/* default */.Z)(_obj, "&.".concat(StepLabel_stepLabelClasses.alternativeLabel), {
        flexDirection: "column"
    }), (0,_define_property/* default */.Z)(_obj, "&.".concat(StepLabel_stepLabelClasses.disabled), {
        cursor: "default"
    }), _obj), ownerState.orientation === "vertical" && {
        textAlign: "left",
        padding: "8px 0"
    });
});
var StepLabelLabel = (0,styled/* default */.ZP)("span", {
    name: "MuiStepLabel",
    slot: "Label",
    overridesResolver: function(props, styles) {
        return styles.label;
    }
})(function(param) {
    var theme = param.theme;
    var _obj;
    return (0,esm_extends/* default */.Z)({}, theme.typography.body2, (_obj = {
        display: "block",
        transition: theme.transitions.create("color", {
            duration: theme.transitions.duration.shortest
        })
    }, (0,_define_property/* default */.Z)(_obj, "&.".concat(StepLabel_stepLabelClasses.active), {
        color: theme.palette.text.primary,
        fontWeight: 500
    }), (0,_define_property/* default */.Z)(_obj, "&.".concat(StepLabel_stepLabelClasses.completed), {
        color: theme.palette.text.primary,
        fontWeight: 500
    }), (0,_define_property/* default */.Z)(_obj, "&.".concat(StepLabel_stepLabelClasses.alternativeLabel), {
        textAlign: "center",
        marginTop: 16
    }), (0,_define_property/* default */.Z)(_obj, "&.".concat(StepLabel_stepLabelClasses.error), {
        color: theme.palette.error.main
    }), _obj));
});
var StepLabelIconContainer = (0,styled/* default */.ZP)("span", {
    name: "MuiStepLabel",
    slot: "IconContainer",
    overridesResolver: function(props, styles) {
        return styles.iconContainer;
    }
})(function() {
    return (0,_define_property/* default */.Z)({
        flexShrink: 0,
        // Fix IE11 issue
        display: "flex",
        paddingRight: 8
    }, "&.".concat(StepLabel_stepLabelClasses.alternativeLabel), {
        paddingRight: 0
    });
});
var StepLabelLabelContainer = (0,styled/* default */.ZP)("span", {
    name: "MuiStepLabel",
    slot: "LabelContainer",
    overridesResolver: function(props, styles) {
        return styles.labelContainer;
    }
})(function(param) {
    var theme = param.theme;
    return {
        width: "100%",
        color: theme.palette.text.secondary
    };
});
var StepLabel = /*#__PURE__*/ react.forwardRef(function StepLabel(inProps, ref) {
    var props = (0,useThemeProps/* default */.Z)({
        props: inProps,
        name: "MuiStepLabel"
    });
    var children = props.children, className = props.className, _componentsProps = props.componentsProps, componentsProps = _componentsProps === void 0 ? {} : _componentsProps, _error = props.error, error = _error === void 0 ? false : _error, iconProp = props.icon, optional = props.optional, StepIconComponentProp = props.StepIconComponent, StepIconProps = props.StepIconProps, other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, StepLabel_excluded);
    var _$ref = react.useContext(StepperContext/* default */.Z), alternativeLabel = _$ref.alternativeLabel, orientation = _$ref.orientation;
    var _$ref1 = react.useContext(StepContext/* default */.Z), active = _$ref1.active, disabled = _$ref1.disabled, completed = _$ref1.completed, iconContext = _$ref1.icon;
    var icon = iconProp || iconContext;
    var StepIconComponent = StepIconComponentProp;
    if (icon && !StepIconComponent) {
        StepIconComponent = StepIcon_StepIcon;
    }
    var ownerState = (0,esm_extends/* default */.Z)({}, props, {
        active: active,
        alternativeLabel: alternativeLabel,
        completed: completed,
        disabled: disabled,
        error: error,
        orientation: orientation
    });
    var classes = StepLabel_useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepLabelRoot, (0,esm_extends/* default */.Z)({
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: [
            icon || StepIconComponent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StepLabelIconContainer, {
                className: classes.iconContainer,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepIconComponent, (0,esm_extends/* default */.Z)({
                    completed: completed,
                    active: active,
                    error: error,
                    icon: icon
                }, StepIconProps))
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StepLabelLabelContainer, {
                className: classes.labelContainer,
                ownerState: ownerState,
                children: [
                    children ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StepLabelLabel, (0,esm_extends/* default */.Z)({
                        className: classes.label,
                        ownerState: ownerState
                    }, componentsProps.label, {
                        children: children
                    })) : null,
                    optional
                ]
            })
        ]
    }));
});
 false ? 0 : void 0;
StepLabel.muiName = "StepLabel";
/* harmony default export */ var StepLabel_StepLabel = (StepLabel);


/***/ }),

/***/ 81025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Stepper_Stepper; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6277);
// EXTERNAL MODULE: ../../node_modules/@mui/base/composeClasses/composeClasses.js
var composeClasses = __webpack_require__(77597);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/useThemeProps.js + 1 modules
var useThemeProps = __webpack_require__(74017);
// EXTERNAL MODULE: ../../node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(67393);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClass/generateUtilityClass.js
var generateUtilityClass = __webpack_require__(72606);
// EXTERNAL MODULE: ../../node_modules/@mui/base/generateUtilityClasses/generateUtilityClasses.js
var generateUtilityClasses = __webpack_require__(98922);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/Stepper/stepperClasses.js

function getStepperUtilityClass(slot) {
    return (0,generateUtilityClass/* default */.Z)("MuiStepper", slot);
}
var stepperClasses = (0,generateUtilityClasses/* default */.Z)("MuiStepper", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel"
]);
/* harmony default export */ var Stepper_stepperClasses = ((/* unused pure expression or super */ null && (stepperClasses)));

// EXTERNAL MODULE: ../../node_modules/@mui/material/utils/capitalize.js + 1 modules
var capitalize = __webpack_require__(8036);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Stepper/StepperContext.js
var StepperContext = __webpack_require__(73451);
// EXTERNAL MODULE: ../../node_modules/@mui/material/Step/StepContext.js
var StepContext = __webpack_require__(14202);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/StepConnector/stepConnectorClasses.js

function getStepConnectorUtilityClass(slot) {
    return (0,generateUtilityClass/* default */.Z)("MuiStepConnector", slot);
}
var stepConnectorClasses = (0,generateUtilityClasses/* default */.Z)("MuiStepConnector", [
    "root",
    "horizontal",
    "vertical",
    "alternativeLabel",
    "active",
    "completed",
    "disabled",
    "line",
    "lineHorizontal",
    "lineVertical"
]);
/* harmony default export */ var StepConnector_stepConnectorClasses = ((/* unused pure expression or super */ null && (stepConnectorClasses)));

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../node_modules/@mui/material/StepConnector/StepConnector.js


var _excluded = [
    "className"
];











var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, orientation = ownerState.orientation, alternativeLabel = ownerState.alternativeLabel, active = ownerState.active, completed = ownerState.completed, disabled = ownerState.disabled;
    var slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel",
            active && "active",
            completed && "completed",
            disabled && "disabled"
        ],
        line: [
            "line",
            "line".concat((0,capitalize/* default */.Z)(orientation))
        ]
    };
    return (0,composeClasses/* default */.Z)(slots, getStepConnectorUtilityClass, classes);
};
var StepConnectorRoot = (0,styled/* default */.ZP)("div", {
    name: "MuiStepConnector",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel,
            ownerState.completed && styles.completed
        ];
    }
})(function(param) {
    var ownerState = param.ownerState;
    return (0,esm_extends/* default */.Z)({
        flex: "1 1 auto"
    }, ownerState.orientation === "vertical" && {
        marginLeft: 12 // half icon
    }, ownerState.alternativeLabel && {
        position: "absolute",
        top: 8 + 4,
        left: "calc(-50% + 20px)",
        right: "calc(50% + 20px)"
    });
});
var StepConnectorLine = (0,styled/* default */.ZP)("span", {
    name: "MuiStepConnector",
    slot: "Line",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.line,
            styles["line".concat((0,capitalize/* default */.Z)(ownerState.orientation))]
        ];
    }
})(function(param) {
    var ownerState = param.ownerState, theme = param.theme;
    return (0,esm_extends/* default */.Z)({
        display: "block",
        borderColor: theme.palette.mode === "light" ? theme.palette.grey[400] : theme.palette.grey[600]
    }, ownerState.orientation === "horizontal" && {
        borderTopStyle: "solid",
        borderTopWidth: 1
    }, ownerState.orientation === "vertical" && {
        borderLeftStyle: "solid",
        borderLeftWidth: 1,
        minHeight: 24
    });
});
var StepConnector = /*#__PURE__*/ react.forwardRef(function StepConnector(inProps, ref) {
    var props = (0,useThemeProps/* default */.Z)({
        props: inProps,
        name: "MuiStepConnector"
    });
    var className = props.className, other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded);
    var _$ref = react.useContext(StepperContext/* default */.Z), alternativeLabel = _$ref.alternativeLabel, _orientation = _$ref.orientation, orientation = _orientation === void 0 ? "horizontal" : _orientation;
    var _$ref1 = react.useContext(StepContext/* default */.Z), active = _$ref1.active, disabled = _$ref1.disabled, completed = _$ref1.completed;
    var ownerState = (0,esm_extends/* default */.Z)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation,
        active: active,
        completed: completed,
        disabled: disabled
    });
    var classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepConnectorRoot, (0,esm_extends/* default */.Z)({
        className: (0,clsx_m/* default */.Z)(classes.root, className),
        ref: ref,
        ownerState: ownerState
    }, other, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepConnectorLine, {
            className: classes.line,
            ownerState: ownerState
        })
    }));
});
 false ? 0 : void 0;
/* harmony default export */ var StepConnector_StepConnector = (StepConnector);

;// CONCATENATED MODULE: ../../node_modules/@mui/material/Stepper/Stepper.js


var Stepper_excluded = [
    "activeStep",
    "alternativeLabel",
    "children",
    "className",
    "connector",
    "nonLinear",
    "orientation"
];











var Stepper_useUtilityClasses = function(ownerState) {
    var orientation = ownerState.orientation, alternativeLabel = ownerState.alternativeLabel, classes = ownerState.classes;
    var slots = {
        root: [
            "root",
            orientation,
            alternativeLabel && "alternativeLabel"
        ]
    };
    return (0,composeClasses/* default */.Z)(slots, getStepperUtilityClass, classes);
};
var StepperRoot = (0,styled/* default */.ZP)("div", {
    name: "MuiStepper",
    slot: "Root",
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.alternativeLabel && styles.alternativeLabel
        ];
    }
})(function(param) {
    var ownerState = param.ownerState;
    return (0,esm_extends/* default */.Z)({
        display: "flex"
    }, ownerState.orientation === "horizontal" && {
        flexDirection: "row",
        alignItems: "center"
    }, ownerState.orientation === "vertical" && {
        flexDirection: "column"
    }, ownerState.alternativeLabel && {
        alignItems: "flex-start"
    });
});
var defaultConnector = /*#__PURE__*/ (0,jsx_runtime.jsx)(StepConnector_StepConnector, {});
var Stepper = /*#__PURE__*/ react.forwardRef(function Stepper(inProps, ref) {
    var props = (0,useThemeProps/* default */.Z)({
        props: inProps,
        name: "MuiStepper"
    });
    var _activeStep = props.activeStep, activeStep = _activeStep === void 0 ? 0 : _activeStep, _alternativeLabel = props.alternativeLabel, alternativeLabel = _alternativeLabel === void 0 ? false : _alternativeLabel, children = props.children, className = props.className, _connector = props.connector, connector = _connector === void 0 ? defaultConnector : _connector, _nonLinear = props.nonLinear, nonLinear = _nonLinear === void 0 ? false : _nonLinear, _orientation = props.orientation, orientation = _orientation === void 0 ? "horizontal" : _orientation, other = (0,objectWithoutPropertiesLoose/* default */.Z)(props, Stepper_excluded);
    var ownerState = (0,esm_extends/* default */.Z)({}, props, {
        alternativeLabel: alternativeLabel,
        orientation: orientation
    });
    var classes = Stepper_useUtilityClasses(ownerState);
    var childrenArray = react.Children.toArray(children).filter(Boolean);
    var steps = childrenArray.map(function(step, index) {
        return /*#__PURE__*/ react.cloneElement(step, (0,esm_extends/* default */.Z)({
            index: index,
            last: index + 1 === childrenArray.length
        }, step.props));
    });
    var contextValue = react.useMemo(function() {
        return {
            activeStep: activeStep,
            alternativeLabel: alternativeLabel,
            connector: connector,
            nonLinear: nonLinear,
            orientation: orientation
        };
    }, [
        activeStep,
        alternativeLabel,
        connector,
        nonLinear,
        orientation
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperContext/* default.Provider */.Z.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StepperRoot, (0,esm_extends/* default */.Z)({
            ownerState: ownerState,
            className: (0,clsx_m/* default */.Z)(classes.root, className),
            ref: ref
        }, other, {
            children: steps
        }))
    });
});
 false ? 0 : void 0;
/* harmony default export */ var Stepper_Stepper = (Stepper);


/***/ }),

/***/ 73451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

/**
 * @ignore - internal component.
 */ var StepperContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
if (false) {}
/* harmony default export */ __webpack_exports__["Z"] = (StepperContext);


/***/ }),

/***/ 73303:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87394);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38457);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88449);
/* harmony import */ var _utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1303);




/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */ function useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    var supportMatchMedia =  true && typeof window.matchMedia !== "undefined";
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(function() {
        if (noSsr && supportMatchMedia) {
            return matchMedia(query).matches;
        }
        if (ssrMatchMedia) {
            return ssrMatchMedia(query).matches;
        } // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    }), 2), match = ref[0], setMatch = ref[1];
    (0,_utils_useEnhancedEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
        var active = true;
        if (!supportMatchMedia) {
            return undefined;
        }
        var queryList = matchMedia(query);
        var updateMatch = function() {
            // Workaround Safari wrong implementation of matchMedia
            // TODO can we remove it?
            // https://github.com/mui/material-ui/pull/17315#issuecomment-528286677
            if (active) {
                setMatch(queryList.matches);
            }
        };
        updateMatch(); // TODO: Use `addEventListener` once support for Safari < 14 is dropped
        queryList.addListener(updateMatch);
        return function() {
            active = false;
            queryList.removeListener(updateMatch);
        };
    }, [
        query,
        matchMedia,
        supportMatchMedia
    ]);
    return match;
} // eslint-disable-next-line no-useless-concat -- Workaround for https://github.com/webpack/webpack/issues/14814
var maybeReactUseSyncExternalStore = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))["useSyncExternalStore" + ""];
function useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia) {
    var getDefaultSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function() {
        return defaultMatches;
    }, [
        defaultMatches
    ]);
    var getServerSnapshot = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
        if (ssrMatchMedia !== null) {
            var matches = ssrMatchMedia(query).matches;
            return function() {
                return matches;
            };
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
        if (matchMedia === null) {
            return [
                getDefaultSnapshot,
                function() {
                    return function() {};
                }
            ];
        }
        var mediaQueryList = matchMedia(query);
        return [
            function() {
                return mediaQueryList.matches;
            },
            function(notify) {
                // TODO: Use `addEventListener` once support for Safari < 14 is dropped
                mediaQueryList.addListener(notify);
                return function() {
                    mediaQueryList.removeListener(notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]), 2), getSnapshot = ref[0], subscribe = ref[1];
    var match = maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function useMediaQuery(queryInput) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var theme = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(); // Wait for jsdom to support the match media feature.
    // All the browsers MUI support have this built-in.
    // This defensive check is here for simplicity.
    // Most of the time, the match media logic isn't central to people tests.
    var supportMatchMedia =  true && typeof window.matchMedia !== "undefined";
    var ref = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        name: "MuiUseMediaQuery",
        props: options,
        theme: theme
    }), _defaultMatches = ref.defaultMatches, defaultMatches = _defaultMatches === void 0 ? false : _defaultMatches, _matchMedia = ref.matchMedia, matchMedia = _matchMedia === void 0 ? supportMatchMedia ? window.matchMedia : null : _matchMedia, _ssrMatchMedia = ref.ssrMatchMedia, ssrMatchMedia = _ssrMatchMedia === void 0 ? null : _ssrMatchMedia, noSsr = ref.noSsr;
    if (false) {}
    var query = typeof queryInput === "function" ? queryInput(theme) : queryInput;
    query = query.replace(/^@media( ?)/m, ""); // TODO: Drop `useMediaQueryOld` and use  `use-sync-external-store` shim in `useMediaQueryNew` once the package is stable
    var useMediaQueryImplementation = maybeReactUseSyncExternalStore !== undefined ? useMediaQueryNew : useMediaQueryOld;
    var match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
    if (false) {}
    return match;
}


/***/ })

}]);